<template>
  <div class="wrap">
    <transition name="fadeIn" mode="out-in">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </transition>
    <transition name="fadeIn" mode="out-in">
      <router-view v-if="!$route.meta.keepAlive && isRouterAlive"></router-view>
    </transition>
    <!-- 原代码是上面的 -->
    <!-- 	<router-view ></router-view> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      isRouterAlive: true
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>

<style>
*,
::before,
::after {
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

@media screen and (min-width: 1024px) {
  html {
    font-size: 204.8px !important;
  }
}

/*去除长按复制*/
* {
  -webkit-touch-callout: none; /*/系统默认菜单被禁用/*/
  -webkit-user-select: none; /*/webkit浏览器/*/
  -moz-user-select: none; /*/火狐/*/
  -ms-user-select: none; /*/IE10/*/
  user-select: none;
}

input,
textarea {
  -webkit-user-select: auto;
}

html {
  min-height: 100%;
  background-color: #f0f0f0;
  /* background-color: #f0f0f0; */
}
body {
  position: relative;
  /* background: #ededed; */
  background: #f0f0f0;
  font-family: "PingFang-SC-Regular", "Segoe UI", "Lucida Grande",
    "Helvetica,Arial", "Microsoft YaHei", "FreeSans,Arimo", "Droid Sans",
    "wenquanyi micro hei", "Hiragino Sans GB", "Hiragino Sans GB W3",
    "FontAwesome", sans-serif, "PingFang-SC-Medium";
  color: #333;
  min-height: 100%;
}

b {
  color: #4c4c4c;
}

a {
  text-decoration: none;
  color: rgba(0, 0, 0, 0.8);
}

ul li {
  list-style-type: none;
}

input[type="number"]::-webkit-inner-spin-button {
  visibility: hidden;
}

input {
  /*-webkit-appearance:none;*/
  /*-webkit-tap-highlight-color: transparent;*/
}

.wrap {
  max-width: 380px;
  /* width: 100%; */
  margin: 0 auto;
  background: #f0f0f0;
}

.fadeIn-enter {
  opacity: 0;
}

.fadeIn-enter-active {
  transition: all 0.3s linear;
}

.fadeIn-leave-active {
  transition: all 0.3s linear;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue